// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationJob.yaml
// Generated: 2026-03-17T14:51:31.226Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateIntegrationJob, UpdateIntegrationJob, IntegrationJob } from '@/types/integration/IntegrationJob';

/**
 * IntegrationJob Service
 * CRUD operations for IntegrationJob via the ABP API.
 */
export const integrationJobService = new EntityService<IntegrationJob, CreateIntegrationJob, UpdateIntegrationJob>(
  '/api/integration/integrationjob',
  'IntegrationJob',
);
